export enum ConsultantUnavailableAction {
  AllowReplacement = 0,
  NoReplacement = 1,
}
